"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toolkit = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrapTable2ToolkitMin = _interopRequireDefault(require("./react-bootstrap-table2-toolkit.min.js"));
var _Icon = require("../Icon");
var _Button = require("../Button");
var _tableContent = require("./tableContent");
var _index = _interopRequireDefault(require("../ToolTip/index.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Toolkit extends _react.Component {
  constructor(props) {
    super(props);
    this.setSearchInputVal = false;
    this.state = {
      searchValue: props.searchValue
    };
    this.input;
    this.timeout;
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }
  handleSearchChange(input) {
    const {
      onTableSearch
    } = this.props;
    this.setState({
      searchValue: input.value
    });
    onTableSearch(input.value, input);
    if (!this.setSearchInputVal) {
      this.setSearchInputVal = true;
    }
  }
  onKeyUp(onSearch) {
    const {
      afterOnSearch,
      delay
    } = this.props;
    const handleDebounce = (func, wait, immediate) => {
      return () => {
        const later = () => {
          this.timeout = null;
          if (!immediate) {
            func.apply(this, arguments);
          }
        };
        const callNow = immediate && !this.timeout;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(later, wait || 0);
        if (callNow) {
          func.apply(this, arguments);
        }
      };
    };
    const debounceCallback = handleDebounce(() => {
      onSearch(this.state.searchValue);
      if (afterOnSearch) {
        afterOnSearch();
      }
    }, delay);
    debounceCallback();
  }
  handleBlur(input) {
    const {
      searchBlurHandler
    } = this.props;
    this.setSearchInputVal = false;
    searchBlurHandler(input.value);
  }
  render() {
    const {
      searchValue
    } = this.state;
    const {
      columns,
      customSearch,
      data,
      defaultSearchValue,
      delay,
      displayOverlay,
      onTableChange,
      isSearch,
      noDataIndication,
      paginationObject,
      rowStyle,
      isSelectable,
      handleRemoveRows,
      selectedRowCount,
      showFlatfile,
      searchInfoText
    } = this.props;
    const customMatchFunc = _ref => {
      let {
        searchText,
        value,
        column
      } = _ref;
      const valueString = "".concat(value);
      if (column.exactSearch) {
        return valueString.toLowerCase() === searchText;
      }
      return valueString.toLowerCase().startsWith(this.state.searchValue.toLowerCase());
    };
    let searchType = {
      defaultSearch: defaultSearchValue
    };
    if (customSearch) {
      searchType = {
        defaultSearch: defaultSearchValue,
        onColumnMatch: customMatchFunc
      };
    }
    return /*#__PURE__*/_react.default.createElement(_reactBootstrapTable2ToolkitMin.default, (0, _extends2.default)({}, this.props, {
      search: searchType,
      columns: columns
    }), props => {
      const searchProps = {
        ...props.searchProps,
        delay
      };
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "table--wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "table--controls"
      }, isSearch && /*#__PURE__*/_react.default.createElement("div", {
        className: "search--container"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "search__icon"
      }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
        icon: ['fas', 'search']
      })), /*#__PURE__*/_react.default.createElement("label", {
        className: "search-label"
      }, /*#__PURE__*/_react.default.createElement(_index.default, {
        text: searchInfoText,
        placement: "bottom"
      }, /*#__PURE__*/_react.default.createElement("input", {
        ref: n => this.input = n,
        onChange: () => this.handleSearchChange(this.input),
        onLoad: () => this.handleSearchChange(this.input),
        onBlur: () => this.handleBlur(this.input),
        onKeyUp: () => this.onKeyUp(searchProps.onSearch),
        type: "text",
        "aria-label": "enter text you want to search",
        className: "form-control",
        placeholder: "Search",
        id: "search-input",
        value: searchValue,
        autoFocus: this.setSearchInputVal
      })))), isSelectable && /*#__PURE__*/_react.default.createElement(_Button.Button, {
        buttontext: "Remove (".concat(selectedRowCount, ") Selected Rows"),
        icon: /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
          icon: ['fas', 'times'],
          size: "1x"
        }),
        onClick: handleRemoveRows,
        className: "btn btn-secondary"
      }), showFlatfile && /*#__PURE__*/_react.default.cloneElement(showFlatfile)), /*#__PURE__*/_react.default.createElement(_tableContent.TableContent, (0, _extends2.default)({
        bordered: false
      }, props.baseProps, this.props, paginationObject, {
        data: data
      }, displayOverlay, {
        rowStyle: rowStyle,
        noDataIndication: noDataIndication,
        onTableChange: onTableChange,
        footerClasses: "table--footer"
      }))));
    });
  }
}
exports.Toolkit = Toolkit;
;